import { render, staticRenderFns } from "./TextMobile.vue?vue&type=template&id=38289c0e&scoped=true"
import script from "./TextMobile.vue?vue&type=script&lang=js"
export * from "./TextMobile.vue?vue&type=script&lang=js"
import style0 from "./TextMobile.vue?vue&type=style&index=0&id=38289c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38289c0e",
  null
  
)

export default component.exports